import { PriceTag } from "@aurelia/ui";

export interface PaymentDetails {
  jazzCashNumber: string | null;
  jazzCashAccountTitle: string | null;
  bankName: string | null;
  bankAccountNumber: string | null;
  bankAccountTitle: string | null;
  bankIban: string | null;
}

export function hasPaymentDetails(payment: PaymentDetails | undefined | null): payment is PaymentDetails {
  return !!payment && !!(payment.jazzCashNumber || payment.bankAccountNumber);
}

export function PaymentInstructions({ payment, advanceAmount }: { payment: PaymentDetails; advanceAmount: number }) {
  return (
    <div className="w-full rounded-2xl border border-accent/30 bg-accent-soft p-6 flex flex-col gap-3 text-left">
      <p className="text-sm font-medium text-accent-strong">
        Send your advance (<PriceTag cents={advanceAmount} className="inline" />) via:
      </p>
      {payment.jazzCashNumber && (
        <div className="text-sm">
          <p className="font-medium">JazzCash</p>
          <p className="text-ink-muted">
            {payment.jazzCashNumber}
            {payment.jazzCashAccountTitle ? ` — ${payment.jazzCashAccountTitle}` : ""}
          </p>
        </div>
      )}
      {payment.bankAccountNumber && (
        <div className="text-sm">
          <p className="font-medium">{payment.bankName || "Bank transfer"}</p>
          <p className="text-ink-muted">
            {payment.bankAccountNumber}
            {payment.bankAccountTitle ? ` — ${payment.bankAccountTitle}` : ""}
          </p>
          {payment.bankIban && <p className="text-ink-muted">IBAN: {payment.bankIban}</p>}
        </div>
      )}
      <p className="text-xs text-ink-muted">
        After sending, share a screenshot of the payment slip on WhatsApp — we'll verify it and confirm your order.
      </p>
    </div>
  );
}
